import Block from '_core_ext/core/common/Block';
import layout from '_core_ext/layout';
import util from '_core_ext/util';
import eventMgr from '_core_ext/core/eventMgr';
import tileServices from './utils/services';
import slickSlider from '../../../components/common/SlickSlider';
const picturefill = require('picturefill');
var ajax = require('_core_ext/ajax');
var progress = require('_core/progress');

export default class ProductTile extends Block {
    init() {
        super.init();
        this.settings = {};
        this.initConfig(this.settings);
        this.isMobile = layout.isMobile();
        tileServices.init();
        
        this.quickShopEnabled = this.config.quickShopEnabled;
        this.quickShopTimeout = null;
        this.quickShopLastOpened = false;

        // Changes made to handle active class on Grid Switcher icons incase of Cache
        if ($(window).innerWidth() > 1024) {
            if ($('.c-product-list--condensed.mixed-template').length && $('button[data-view-mode="condensed"]').hasClass('active')) {
                $('button[data-view-mode="condensed"]').removeClass('active').addClass('unselected');
                $('button[data-view-mode="sparse"]').addClass('active').removeClass('unselected').attr('disabled','disabled');
            }
        } else {
            if ($('.c-product-list--condensed.mixed-template').length && $('button[data-view-mode="sparse"]').hasClass('active')) {
                $('button[data-view-mode="sparse"]').removeClass('active').addClass('unselected');
                $('button[data-view-mode="condensed"]').addClass('active').removeClass('unselected').attr('disabled','disabled');
            }
        }
        
        if ($(window).width() > 1024) {
            if ($('.c-refinements__content-inner').hasClass('largeDevices')){
                const newscroll = document.querySelector('.largeDevices');
                let isDown = false;
                let startX;
                let scrollLeft;
    
                newscroll.addEventListener('mousedown', (e) => {
                    let rect = newscroll.getBoundingClientRect();
                    isDown = true;
                    newscroll.classList.add('active');
                    // Get initial mouse position
                    startX = e.pageX - rect.left;
                    // Get initial scroll position in pixels from left
                    scrollLeft = newscroll.scrollLeft;
                });
    
                newscroll.addEventListener('mouseleave', () => {
                    isDown = false;
                    newscroll.dataset.dragging = false;
                    newscroll.classList.remove('active');
                });
    
                newscroll.addEventListener('mouseup', () => {
                    isDown = false;
                    newscroll.dataset.dragging = false;
                    newscroll.classList.remove('active');
                });
    
                newscroll.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    let rect = newscroll.getBoundingClientRect();
                    e.preventDefault();
                    newscroll.dataset.dragging = true;
                    // Get new mouse position
                    const x = e.pageX - rect.left;
                    // Get distance mouse has moved (new mouse position minus initial mouse position)
                    const walk = (x - startX);
                    // Update scroll position of slider from left (amount mouse has moved minus initial scroll position)
                    newscroll.scrollLeft = scrollLeft - walk;
                });
            }
        }

        this.event('click', '.swatch-list .swatch:not(.add-bag)', this.onClickSwatch.bind(this));
        this.event('click', '.swatch-list .swatch.add-bag', this.onClickSwatchAdd.bind(this));
        if ($(window).width() > 992) {
            this.event('mouseenter', '.swatch-list .swatch.js-color-swatch', this.onMouseEnterSwatch.bind(this));
            this.event('mouseleave', '.swatch-list li', this.onSwatchListMouseLeave.bind(this));
        }
        $(document).on('mouseenter','.c-product-tile__image', function() {
            $(this).find('.c-product-slider__prev').css('display','flex');
            $(this).find('.c-product-slider__next').css('display','flex');
            $(this).find('.c-product-slider__prev').removeClass('d-none');
            $(this).find('.c-product-slider__next').removeClass('d-none');
           
        });
        $(document).on('mouseleave','.c-product-tile__image',function() {
            $(this).find('.c-product-slider__prev').css('display','none');
            $(this).find('.c-product-slider__next').css('display','none');
        });

        $(document).on('click', '.quick-shop-modal .close, .quick-shop-modal .icon-close', function (e) {
            $('.quick-shop-modal').remove();
        });

        $(document).on('click', '.quick-shop-modal', function (e) {
            if (e.target === $('.quick-shop-modal')[0]) {
                $('.quick-shop-modal').remove();
            }
        });

        
        const createModalCallback = this.createModalHTML;
        $(document).on('click', '.quickshop-modal-content  .c-product-variations__link', function (e) {
            e.preventDefault();
            if ($(this).parent('.c-product-variations__subitem').hasClass('selected')) {
                return false;
            }
            var href = this.href;
            // updateContent(this.href, this.getAttribute('hrefbrowser'), this, editCart, isVariantSelection);
            var params = {
                Quantity: '1',
                format: 'ajax'
            };
            var imageParams = {
                format: 'ajax',
                editCart: false,
            }
            var imageUrl = $(this).data('product-images-url');
            progress.show($('.quickshop-modal-content'));
            ajax.load({
                url: util.appendParamsToUrl(href, params),
                callback: function (variationRes) {
                    $.ajax({
                        method: "get",
                        url: util.appendParamsToUrl(imageUrl, imageParams),
                        success: function (imgRes) {
                            var modalHtml = createModalCallback(variationRes, imgRes);
                            $(".quick-shop-modal").replaceWith(modalHtml);
                            progress.hide($('.quickshop-modal-content'))
                        }
                    });
                }
            });
        });

        if (this.quickShopEnabled) {
            this.updateQuickShopReference();

            if ($(window).width() > 992) {
                this.event('mouseleave','.c-product-tile__wrapper', this.hideQuickShop.bind(this));
                this.event('mouseenter', '.js-product-tile-image', this.showQuickShopWithDelay.bind(this, 500));
            }

            this.subscribeToQuickShopEvents();
        }
        if ($(window).innerWidth() <= 1199) {
            $('.addbag-container').removeClass('d-none');
            var isMobileView = this.isMobileView;
            var isCondensedList = this.isCondensedList;
            $('.product-tile .js-product-tile-image').on('mouseleave touchmove', function(){
                if (! (isCondensedList() && isMobileView()) ) {
                    $(this).find('.c-quick-shop').addClass('d-none');
                }
            });
            $(window).scroll(function() {
                $('.c-quick-shop').addClass('quickshowClass').show().removeClass('d-none');
                $('.product-image').find('.c-product-slider__prev').css('display','none');
                $('.product-image').find('.c-product-slider__next').css('display','none');
                $('.c-product-image .slick-arrow').removeClass('arrow-hide-class');
                clearTimeout($.data(this, 'scrollTimer'));
                $.data(this, 'scrollTimer', setTimeout(function() {
                    $('.c-quick-shop').removeClass('quickshowClass');
                    $('.addbag-container').removeClass('d-none');
                    $('.js-quick-shop-content .size, .js-quick-shop-content .length').addClass('d-none');
                    $('.product-image').find('.c-product-slider__prev').css('display','flex');
                    $('.product-image').find('.c-product-slider__next').css('display','flex');
                    $('.product-image').find('.c-product-slider__prev').removeClass('d-none');
                    $('.product-image').find('.c-product-slider__next').removeClass('d-none');
                    $('.c-product-image .slick-arrow').addClass('arrow-hide-class');
                }, 250));
            });
        }
    }

    isCondensedList() {
        return $('.product-tile .js-product-tile-image').closest('.c-product-list--condensed').length > 0;
    }

    isMobileView() {
        return $(window).width() < 767;
    }

    /**
    * @description updates picture srcset attributes
    *
    * @param {Object} data
    */

    updateSRCSET(data) {
        if (!data) {
            return;
        }

        this.$el.find('.js-srcset-mobile').attr('srcset', data.srcMobile);
        this.$el.find('.js-srcset-tablet').attr('srcset', data.srcTablet);
        this.$el.find('.js-srcset-desktop').attr('srcset', data.srcDesktop);
    }

    /**
    * @description updates image attributes and reinits picturefill polifil
    *
    * @param {jQuery} $tile
    * @param {Object} data
    */

    updateAttributes($element, data) {
        if (!data || !$element) {
            return;
        }

        $element.attr({
            srcset: data.src,
            alt: data.alt,
            title: data.title
        });
        picturefill({
            reevaluate: true,
            elements: [$element[0]]
        });
    }

    onSwatchListMouseLeave() {
        var $tile = this.$el;
        var tileHoveredImage = $tile.find('.product-hovered-image');
        var tileSelectedImage = $tile.find('.product-selected-image');
        $(tileHoveredImage).hide();
        $(tileSelectedImage).show();
    }

    onClickSwatchAdd(el, event) {
        event.preventDefault();
        if (this.isCondensedList() && this.isMobileView()) {
            this.showQuickShopModal(this.$el)
        } else {
            this.$el.find('.size').length ? this.$el.find('.size').removeClass('d-none') : this.$el.find('.length').removeClass('d-none');
            this.$el.find('.addbag-container').addClass('d-none');
        }
        this.$el.find('.thumb-link').removeClass('video-link');
       

    }
    onClickSwatch(el, event) {
        event.preventDefault();
        if ($(window).innerWidth() <= 1199) {
            $('.js-product-tile').find('.size, .length').addClass('d-none');
        }
        var $swatch = $(el);
        var tileUrl = $swatch.data('tile-url');
        if (!tileUrl) {
            return;
        }
        $swatch.closest('.product-tile').find('a.thumb-link').removeClass('video-link');
        $swatch.closest('.swatch-list').find('.swatch.js-selected').removeClass('js-selected');
        $swatch.addClass('js-selected');
        let isColorSwatch = $swatch.hasClass('js-color-swatch');

        this.updateTile(tileUrl, isColorSwatch);
    }

    handleClickSwatchPictureFill($swatch) {
        if ($swatch.hasClass('selected')) {
            return;
        }

        var $tile = this.$el;
        $swatch.closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $swatch.addClass('selected');
        $tile.find('.thumb-link').attr('href', $swatch.attr('href'));
        $tile.find('name-link').attr('href', $swatch.attr('href'));

        var data = $swatch.children('img').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title,
            srcMobile: data.srcMobile,
            srcTablet: data.srcTablet,
            srcDesktop: data.srcDesktop
        };
        $thumb.attr(currentAttrs);
        this.updateSRCSET(data);
        $thumb.data('current', currentAttrs);

        picturefill({
            reevaluate: true,
            elements: [$thumb[0]]
        });
    }

    onMouseEnterSwatch(el) {
        var $swatch = $(el);
        // get current thumb details
        var $tile = this.$el;
        var data = $swatch.children('img').filter(':first').data('thumb');


        var tileHoveredImage = $tile.find('.product-hovered-image');
        var tileSelectedImage = $tile.find('.product-selected-image');

        if ($(tileHoveredImage).html() == '') {
            var componentImg = $tile.find('.product-image .thumb-link img').eq(0);
            $(tileHoveredImage).html(componentImg.clone());
        }

        var $thumb = tileHoveredImage.find('img').eq(0);
        this.updateAttributes($thumb, data);
        if (!$swatch.hasClass('selected')) {
            $(tileSelectedImage).hide();
            $(tileHoveredImage).show();
        }
    }

    showQuickShopWithDelay(milliseconds, el, event) {
        this.quickShopTimeout = setTimeout(this.showQuickShop.bind(this, false, el, event), milliseconds);
    }

    showQuickShopModal(tile) {
        var tileQuickShop = tile.find('.c-quick-shop');
        var dataJsonConfig = tileQuickShop.data('json-config');
        var pid = dataJsonConfig.masterProductId;
        var selectedAttrs = dataJsonConfig.selectedVariationAttributes;
        var variationUrl = tileQuickShop.data('variation-url');
        var productDetailsJSON = tileQuickShop.data('product-details');
        var params = {
            format: 'ajax',
            pid: pid,
            Quantity: 1,
            variationGroupID: productDetailsJSON.variationgroupid,
            cgid: dataJsonConfig.cid
        }
        var imageParams = {
            pid: pid,
            format: 'ajax',
            editCart: false,
        }
        for (var attr in selectedAttrs) {
            params["dwvar_" + pid + "_" + attr] = selectedAttrs[attr];
            imageParams["dwvar_" + pid + "_" + attr] = selectedAttrs[attr];
        }
        const callback = this.createModalHTML;
        $.ajax({
            method: "get",
            contentType: "text/html;charset=UTF-8",
            url: util.appendParamsToUrl(variationUrl, params),
            success: function (variationRes) {
                $.ajax({
                    method: "get",
                    url: util.appendParamsToUrl(variationUrl.replace('Variation', 'GetMainImageSection'), imageParams),
                    success: function (imgRes) {
                        var modalHtml = callback(variationRes, imgRes);
                        $(tile).append(modalHtml);
                    }
                });
            }
        })
    }
    createModalHTML(html, imgHtml) {
        html = `<div>${html}</div>`;
        var productId = $(html).find('#product-number').text();
        var productTitle = $(html).find('#product-name').html();
        var priceData = $(html).find('#product-price').prop('outerHTML');
        var attributes = $(html).find('.c-product-variations');
        var attributeHtml;
        var atcButton = $(html).find('.c-product-details__button');
        var productUrl = $(html).find('.wash .selected a, .color .selected a').attr('hrefbrowser');
        var addToCartData;
        var attrCount = 0;
        var selectedAttrCount = 0;

        attributes.find('.c-product-variations__item h5').each(function() {
            const $h5 = $(this);
            let originalText = $h5.text().trim(); 

            if (originalText.toLowerCase().indexOf('select') === -1) {
                let newText = 'select ' + originalText;
                $h5.text(newText);
            }
        });
        attributeHtml = attributes.prop('outerHTML');
        $(html).find('.c-product-variations__list .c-product-variations__item').each(function () {
            var len = $(this).find(".selected").length;
            attrCount++;
            if (len) {
                selectedAttrCount++;
            }
        });
        if (selectedAttrCount !== attrCount) {
            atcButton.addClass('disabled');
        }

        if (atcButton.attr('id') === 'add-to-cart') {
            var addToCartHtml = atcButton.parents('form');
            addToCartHtml.find('#product-price').remove();
            addToCartHtml.find('.c-product-details__button').removeClass('js-pdp-main-add-to-bag');
            addToCartData = addToCartHtml.prop('outerHTML');
        } else {
            addToCartData = atcButton.prop('outerHTML');
        }

        var imgSrc = $(imgHtml).find('#pdp-images-mobile-slider img').attr('srcset');
        var modalHtml = `<div id="quickshopModal" class="quick-shop-modal">
            <div class="quickshop-modal-content">
                <div class="details-section">
                    <div class="product-image">
                        <a href="${productUrl}">
                            <img src="${imgSrc}" alt="product image">
                        </a>
                    </div>
                    <div class="product-details">
                        <div class="pid">${productId}</div>
                        <a href="${productUrl}">
                            <div class="product-title">${productTitle}</div>
                        </a>
                        <div class="price-section">
                            ${priceData}
                        </div>
                    </div>
                    <div class="close">
                        <i class="sprite-icon icon-close" style=""></i>
                    </div>
                </div>
                <div class="attribute-section">
                    ${attributeHtml}
                </div>
                <div class="c-product-availability__container js-email-me-container"></div>
                <div class="addtobag-container">
                    ${addToCartData}
                </div>
            </div>
        </div>`;
        return modalHtml;
    }

    clearTimer() {
        if (this.quickShopTimeout) {
            clearTimeout(this.quickShopTimeout);
        }
    }

    showQuickShop(siblingQuickShopHide, el, event) {
        event.preventDefault();
        var $currentEl = this.$el;
        if ($(event.target).parents('.js-slider-button').length 
            || $(event.target).hasClass('js-slider-button') 
            || $(event.target).closest('.c-product-tile').hasClass('c-product-tile-large')) {
            return;
        }
        
        if (siblingQuickShopHide) {
            this.quickShopLastOpened = true;
            this.emitter.emit('produtTile.quickShop.hideSiblings');
        }
        if ($(window).innerWidth() <= 1199) {
            this.quickShop.show();
        } else {
            this.quickShop.show();
            if(!$('.addbag-container').hasClass('show')) {
                $currentEl.find('.size').length ? $currentEl.find('.size').removeClass('d-none') : $currentEl.find('.length').removeClass('d-none');
            }
        }

    }

    hideQuickShop(leaveLastOpened) {
        if (leaveLastOpened) {
            if (this.quickShopLastOpened) {
                this.quickShopLastOpened = false;
                return;
            }
        }
        this.clearTimer();
        var $currentEl = this.$el;
        $currentEl.find('.color-swatches').removeClass('d-none');
        $currentEl.find('.size, .length').addClass('d-none');
        $currentEl.find('.c-quick-shop__close').addClass('d-none');
        this.quickShop.hide();
    }

    /**
    * @param {Object} data - contains additional data that will be passed to event listeners
    */
    onProductAddedToCart(data) { 
        var recommCarousel = this.$el.parents().hasClass('recommendations-carousel');
        var recentlyViewedCarousel = this.$el.parents().hasClass('recently-viewed-carousel');
        var quickshopEl = this.$el.find('.c-product-tile__wrapper .c-quick-shop');
        if(recommCarousel || recentlyViewedCarousel){
            this.$el.trigger('quickShop.addedToCartCarousel', [data, $(quickshopEl)]);
        } else {
            var quickshopAddedItemBlock = quickshopEl.find('.c-variations__list #product-option-size .js-product-variations__subitem.selected');
            if(quickshopAddedItemBlock){
               var itemSize = quickshopAddedItemBlock.text().trim();
               data.itemSize = itemSize;
            }
            this.$el.trigger('quickShop.addedToCart', [data, $(quickshopEl)]);
        }

        if (this.quickShopEnabled && !layout.isSmallView()) {
            return;
        }

        this.emitter.emit('produtTile.product.added.to.cart');
    }

    onNotifyMe(params) {
        params = Object.assign({}, params, {productTileCmpId: this.id});
        this.emitter.emit('produtTile.notifyme', params);
    }

    notifyMeFormSubmitted() {
        if (!this.quickShopEnabled) {
            return;
        }
        this.quickShop.resetQuickShop();
    }

    onNotifyMeDialogClose() {
        if (!this.quickShopEnabled) {
            return;
        }
        this.quickShop.onNotifyMeDialogClose();
    }

    subscribeToQuickShopEvents() {
        this.onChild('quickShop', 'quickShop.product.added.to.cart', this.onProductAddedToCart.bind(this));
        this.onChild('quickShop', 'quickShop.notify.me', this.onNotifyMe.bind(this));
    }

    updateQuickShopReference() {
        this.getById('quickShop', (quickShop) => {
            this.quickShop = quickShop;
        });
    }

    getTileContent(tileUrl) {
        return eventMgr.execute('get.product.tile.content', {
            url: tileUrl,
            loaderLocation: this.$el.parent()
        });
    }

    updateTileContent(tileHtml, isColorSwatch) {
        this.$el.html(tileHtml);
        const $sliders = this.$el.find('.plp-slick-slider');

        $sliders.each(function () {
            const $slider = $(this);
            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    prevArrow:
                        "<i class='icon-arrow-left slick-prev pull-left slick-arrow'></i>",
                    nextArrow:
                        "<i class='icon-arrow-right slick-next pull-right slick-arrow'></i>"
                });

                $slider.find('.slick-prev, .slick-next').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            }
        });
        if (!isColorSwatch) {
            this.$el.find('.size').length ? this.$el.find('.size').removeClass('d-none') : this.$el.find('.length').removeClass('d-none');
            this.$el.find('.addbag-container').addClass('d-none');
        }
        $(document).trigger('init.all.carousels.insideselector', this.$el);
        return eventMgr.execute('components.update', this.$el);
    }

    handleQuickShopUpdate() {
        this.quickShopTimeout = null;
        this.quickShopLastOpened = false;
        this.updateQuickShopReference();
        this.subscribeToQuickShopEvents();
        if ($(window).innerWidth() <= 1199)
            this.quickShop.show();


    }
    updateTile(tileUrl, isColorSwatch) {
        this.getTileContent(tileUrl)
            .then((res) => this.updateTileContent(res, isColorSwatch))
            .then(this.handleQuickShopUpdate.bind(this));
    }
}